import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Constants
import BALANCE from 'constants/balance';

// Actions
import { changeBalanceType } from 'store/ducks/balance/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './BalanceTypeFilter.styles';

const BalanceTypeFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedBalanceType = useSelector(
    (state: ApplicationState) => state.balance.balanceType,
  );

  const handlePayment = (payment: any) => {
    const updated = [...selectedBalanceType];
    const index = selectedBalanceType.findIndex((e) => e.key === payment.KEY);

    if (index === -1) updated.push({ key: payment.KEY, value: payment.VALUE });
    else updated.splice(index, 1);

    dispatch(
      changeBalanceType({
        balanceType: updated,
      }),
    );
  };
  return (
    <List dense>
      {BALANCE.TYPE.map((item) => (
        <ListItem key={item.KEY} button>
          <ListItemText
            id={item.VALUE}
            primary={item.VALUE}
            onClick={() => handlePayment(item)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              color='primary'
              onChange={() => handlePayment(item)}
              checked={!!selectedBalanceType.find((e) => e.key === item.KEY)}
              inputProps={{ 'aria-labelledby': item.VALUE }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export default BalanceTypeFilter;
export { BalanceTypeFilter };
